import { differenceInSeconds } from 'date-fns';

// Custom timer for each screen
export const SESSION_TIMEOUT_KEY = `timeout-date${window.location.pathname.replaceAll(
  '/',
  '-',
)}`;

// Several independent timers can live on the same screen, each under its own key
export const getTimerKey = (timerName?: string) =>
  timerName ? `${SESSION_TIMEOUT_KEY}-${timerName}` : SESSION_TIMEOUT_KEY;

// Returns remaining seconds if a valid timer exists in storage; otherwise resets the timer start time
export const getInitialTimeout = (
  secondsToWait: number,
  timerName?: string,
): number | undefined => {
  const key = getTimerKey(timerName);
  const startDateFromSession = sessionStorage.getItem(key);

  const start = startDateFromSession
    ? new Date(startDateFromSession)
    : new Date();

  const secondsPassed = differenceInSeconds(new Date(), start);

  const isTimeValid = secondsPassed && secondsPassed < secondsToWait;

  if (isTimeValid) {
    return secondsToWait - secondsPassed;
  }

  // Reset the timestamp so the next call starts a fresh countdown
  if (!startDateFromSession) sessionStorage.setItem(key, new Date().toString());
};

export const DEFAULT_TIMEOUT_SECONDS = 60;

// Clears any expired timer and returns true only if a live countdown is still in progress
export const isTimerAlreadyStarted = (
  secondsToWait: number = DEFAULT_TIMEOUT_SECONDS,
  timerName?: string,
) => {
  const secondsToWaitInProgress = getInitialTimeout(secondsToWait, timerName);
  const currentTimerAlreadyExists = Boolean(secondsToWaitInProgress);

  if (!currentTimerAlreadyExists) clearTimer(timerName);

  return currentTimerAlreadyExists;
};

// Guards against a redundant removeItem call when the key does not exist
export const clearTimer = (timerName?: string) =>
  sessionStorage.getItem(getTimerKey(timerName)) &&
  sessionStorage.removeItem(getTimerKey(timerName));
